import { Consent, PaymentService, Transaction } from '~/types';

type DetailObject = { name: string; value: string };

export const getServiceParameters = (
  transaction?: Transaction | Consent,
  service?: PaymentService
): (DetailObject | null)[] | null => {
  if (!transaction || !service) return null;

  return Object.entries(transaction.details?.service?.parameters ?? {}).map(([paramId, value]) => {
    const param = service?.parameters?.[paramId];
    const name = param?.name ?? paramId;
    if (typeof value === 'string') return { name, value };
    if (typeof value === 'number') return { name, value: value.toString() };
    if (typeof value === 'object' && value.hasOwnProperty('name') && value.hasOwnProperty('value'))
      return {
        name: value.name,
        value: typeof value.value === 'number' ? value.value.toString() : value.value,
      };
    return null;
  });
};
